// @ts-check
import './custom-shape-content.css';
import { h } from 'preact';

import PlotNumbersStatusCount from '../../../PlotNumbersStatusCount';

const { __, sprintf } = wp.i18n;

/**
 * @param {object} props
 * @param {string=} props.name
 * @param {import('../../../../types').PlotNumber[]=} props.plotNumbers
 * @param {import('../../../../types').Status[]} props.statuses
 * @returns
 */
export default function CustomShapeContent({
	name,
	plotNumbers,
	statuses
}) {
	return (
		<div className="custom-shape-content-container">
			<div className="custom-shape-content-header">
				{name && <h2 className="custom-shape-content-name">{name}</h2>}
				{Array.isArray(plotNumbers) && <p className="custom-shape-content-house-count">{sprintf(__('Number: %d', 'real-estate-project'), plotNumbers.length)}</p>}
			</div>
			{Array.isArray(plotNumbers) && <div className="custom-shape-content-body">
				<p>
					{statuses.map(status => (
						<PlotNumbersStatusCount plotNumbers={plotNumbers} status={status} />
					))}
				</p>
			</div>}
		</div>
	);
}
